// Unicode 15.0の絵文字コード
// https://emojipedia.org/unicode-15.0
export const unicode150Codes = [
  ":shaking_face:",
  ":pink_heart:",
  ":light_blue_heart:",
  ":grey_heart:",
  ":leftwards_pushing_hand:",
  ":rightwards_pushing_hand:",
  ":moose:",
  ":donkey:",
  ":wing:",
  ":goose:",
  ":jellyfish:",
  ":hyacinth:",
  ":ginger_root:",
  ":pea_pod:",
  ":folding_hand_fan:",
  ":hair_pick:",
  ":maracas:",
  ":flute:",
  ":khanda:",
  ":wireless:",
];
